import { Alert, AlertTitle, useRoles } from "ra-friendsofbabba";
import { Collapse, Typography, makeStyles } from "@material-ui/core";
import React, { useMemo } from "react";

import classnames from "classnames";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  info: {
    "& *": {
      color: theme.palette.text.primary[500],
    },
  },

  form: {
    width: "70%",
    minWidth: "960px",
    maxWidth: "1024px",
    margin: "1em auto",
    [theme.breakpoints.down("md")]: {
      minWidth: "100%",
    },
  },
}));

const HelpBlock = ({
  resource,
  context,
  visible = true,
  visibleFor = [],
  form = false,
}) => {
  const roles = useRoles();
  const classes = useStyles();
  const translate = useTranslate();
  const isVisible = useMemo(() => {
    const roleCodes = roles.map((role) => role.code);
    return (
      visibleFor.length === 0 ||
      visibleFor.some((role) => roleCodes.includes(role))
    );
  }, [visibleFor, roles]);
  if (!isVisible) {
    return null;
  }
  return (
    <Collapse in={visible && isVisible}>
      <Alert
        elevation={1}
        severity="info"
        variant="filled"
        className={classnames(classes.root, classes.info, form && classes.form)}
      >
        <AlertTitle>
          {translate(`resources.${resource}.help-block.title.${context}`)}
        </AlertTitle>
        <Typography variant="body2" align="justify">
          <span
            dangerouslySetInnerHTML={{
              __html: translate(
                `resources.${resource}.help-block.content.${context}`
              ),
            }}
          />
        </Typography>
      </Alert>
    </Collapse>
  );
};

export default HelpBlock;
